var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    viewBox: "0 0 1595 1248",
    enableBackground: "new 0 0 1595 1248",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    d: " M642.500000,235.750000  C636.253601,240.808899 631.951477,247.501175 627.544006,254.029709  C612.845459,275.801880 598.715210,297.969452 587.106262,321.552307  C575.713379,344.696442 567.869690,368.996643 565.933472,394.995056  C564.770020,410.616333 566.773438,426.023468 567.986267,441.501068  C568.246826,444.827057 568.589905,448.177185 568.453491,451.498077  C567.980347,463.014069 569.833252,474.425537 569.285889,486.013489  C568.784363,496.632355 569.494202,507.357788 568.455017,517.995605  C567.642578,526.312744 566.379639,534.580872 563.500000,542.500000  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25,
    d: " M509.000000,575.000000  C494.421722,570.576721 483.956909,560.871216 474.961517,549.029236  C458.558807,527.435852 456.158112,504.201050 466.594879,479.540161  C469.353912,473.020874 473.455963,466.988220 478.579224,462.082733  C487.662140,453.385925 496.365845,454.151855 505.420898,461.596222  C515.929932,470.235901 520.309631,482.082825 521.045227,495.497528  C521.415344,502.247406 520.146118,508.072784 514.526855,512.533813  C507.874817,517.814819 500.137115,518.704895 492.000000,513.250000  "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 21,
    d: " M707.500000,1070.500000  C708.000000,1078.166626 708.554749,1085.830322 708.987427,1093.500732  C709.684326,1105.854004 713.243774,1117.563110 717.587463,1128.966675  C725.113892,1148.726196 736.960999,1165.483765 755.066833,1176.894043  C767.568970,1184.772827 781.411133,1189.924561 796.013306,1192.422363  C810.763794,1194.945435 825.619446,1194.360474 840.506470,1193.075073  C860.901917,1191.314087 879.605408,1185.053223 896.492126,1173.488525  C910.197083,1164.102661 920.636292,1151.754395 929.025635,1137.515137  C935.395935,1126.702759 940.521362,1115.140137 948.070984,1105.053101  C951.094788,1101.013184 951.775330,1097.076660 951.784729,1092.000488  C951.802673,1082.332031 953.228699,1072.629028 954.561890,1063.008545  C956.691284,1047.643066 957.371460,1032.333374 954.500000,1017.000000  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 21,
    d: " M393.500000,772.500000  C384.555603,769.857666 376.006134,766.805664 368.873260,760.135498  C362.946747,754.593445 359.221100,747.010681 364.526154,737.514587  C366.531708,733.924622 368.547241,730.268372 371.116943,727.094666  C372.464203,725.430786 372.652954,724.212158 371.998230,722.500671  C365.066925,704.381653 370.266510,687.844482 379.066132,672.036804  C388.498596,655.092285 403.277771,643.071716 417.908295,630.889893  C423.202728,626.481506 428.417664,623.351196 435.484772,622.803467  C439.442139,622.496643 443.432068,620.820190 447.067017,618.610229  C448.830109,617.538269 450.833466,616.628540 453.535126,617.372498  C464.881927,620.496704 476.679596,621.621521 488.009979,624.966248  C505.796814,630.216919 520.302795,640.248840 531.992249,654.506348  C537.045227,660.669434 541.996460,666.899353 546.557312,673.460205  C552.463623,681.956604 551.863892,690.171753 546.496521,698.497742  C544.016907,702.344238 541.533936,706.189453 538.985596,709.990356  C537.720764,711.876831 536.761719,713.583191 537.955322,716.021912  C541.396362,723.052490 539.454834,730.700989 539.799683,738.009460  C540.726440,757.652039 543.599182,777.044067 546.042358,796.494690  C547.867126,811.021667 549.164612,825.600220 545.887634,839.974365  C541.877380,857.565125 530.797241,868.848572 513.536682,874.609924  C499.458679,879.309021 485.143768,880.727234 470.502289,879.956360  C464.120178,879.620300 459.025574,876.408813 454.469177,872.032104  C447.575439,865.410095 443.370850,856.944031 438.589111,848.946716  C426.473450,828.683716 415.482452,807.753296 402.496826,788.002075  C400.185974,784.487305 397.673096,781.094421 395.541077,777.475830  C392.945343,773.070068 393.489716,772.250977 397.968567,768.957275  C405.355408,763.525024 414.264038,761.742493 422.550507,758.634644  C456.090576,746.055542 489.073547,732.191589 521.459656,716.914490  C526.340942,714.611877 531.167114,713.239990 536.500000,713.500000  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25,
    d: " M1061.000000,83.500000  C1050.895264,74.718651 1039.250732,74.934418 1027.528320,78.590935  C1004.739807,85.699265 984.003723,96.830215 965.500000,112.000000  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: " M1069.000000,170.000000  C1082.418579,160.357788 1095.625488,150.381485 1104.929199,136.452713  C1115.030518,121.329605 1114.977905,105.377350 1105.564331,92.951286  C1101.707642,87.860497 1096.524292,85.045853 1091.000000,82.500000  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: " M990.000000,151.000000  C980.007141,156.281815 969.560242,160.525681 958.996033,164.489487  C950.151855,167.807922 941.895569,172.889053 932.003906,173.149399  C930.580994,173.186844 928.988281,173.227936 927.500000,173.500000  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M1109.500000,919.000000  C1112.680054,935.915405 1122.720337,943.769653 1141.500000,943.996765  C1157.094727,944.185364 1171.044678,938.608582 1184.487915,931.477173  C1203.796997,921.234131 1219.811035,906.994263 1234.029907,890.525818  C1248.954834,873.239563 1259.450562,853.862244 1262.444336,830.992737  C1264.806274,812.949707 1261.868652,796.708130 1244.994141,786.009338  C1244.875244,785.933960 1244.666626,786.000000 1244.500000,786.000000  "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25,
    d: " M1220.500000,801.500000  C1209.877686,822.884827 1193.067261,838.247253 1173.016968,850.527771  C1164.581543,855.694397 1156.333374,861.166626 1148.000000,866.499939  "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: " M949.000000,78.000000  C928.086060,92.695038 909.697083,110.196915 892.513977,129.012787  C875.561646,147.576096 861.437927,168.030334 850.957214,190.980469  C841.697388,211.257309 832.888611,231.751923 822.500000,251.500000  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 23,
    d: " M803.000000,282.000000  C796.505066,289.797394 789.815613,297.748230 780.432129,301.844452  C762.085815,309.853271 751.498840,303.999268 745.020020,285.492981  C742.249878,277.580231 741.146729,269.501038 741.273254,260.996613  C741.381531,253.719955 737.475708,247.113998 734.500000,240.500000  "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 23,
    d: " M627.500000,431.000000  C629.070190,440.998596 635.356201,446.909027 644.517883,449.946106  C653.209290,452.827332 661.194214,449.710419 668.446228,445.409332  C686.310852,434.814026 696.794434,418.069092 704.400635,399.459381  C711.238342,382.729797 715.123535,365.151398 714.355469,347.006104  C713.781982,333.455383 712.602417,319.904358 704.590088,307.939697  C697.167908,296.856445 687.308655,290.429291 673.996826,290.154083  C669.942505,290.070251 665.636963,291.088715 662.000000,293.500000  "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 23,
    d: " M622.500000,356.500000  C616.202698,366.802856 613.434082,378.358795 611.659729,390.024292  C610.078918,400.417603 611.138855,410.845764 616.019592,420.490082  C618.427368,425.247742 622.005005,428.891571 627.000000,431.000000  "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M1114.000000,642.500000  C1114.055298,651.519348 1115.706787,660.026733 1122.004883,666.995544  C1127.089966,672.622131 1132.340698,673.955627 1139.404419,667.397034  C1149.713867,657.824829 1151.076538,645.091980 1149.372314,632.016663  C1148.523438,625.504028 1145.916992,619.425903 1140.514038,614.982971  C1133.460205,609.182373 1125.466675,608.439636 1117.005371,610.521606  C1095.437500,615.828735 1078.435547,629.156128 1075.724854,654.024536  C1073.011597,678.914978 1087.956787,707.151917 1115.077026,713.151733  C1131.335449,716.748657 1147.304321,714.333862 1158.622437,699.090881  C1163.450806,692.588013 1168.887207,686.535828 1173.000000,679.500000  "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: " M660.000000,779.000000  C620.949341,800.804382 592.190430,832.511169 571.000000,871.500000  "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M708.000000,812.000000  C709.666687,809.500000 711.333313,807.000000 713.000000,804.500000  "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M746.000000,783.500000  C760.224487,785.699646 768.581421,799.832642 770.410767,811.513977  C773.183411,829.218628 768.123474,845.476990 760.014160,861.007385  C758.911011,863.120178 758.000000,865.333313 757.000000,867.500000  "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25,
    d: " M660.000000,956.000000  C645.543823,962.312805 630.480347,966.630432 614.992249,969.457642  C609.874451,970.391968 604.627136,971.597961 599.508606,971.333374  C590.201965,970.852112 584.580444,964.982117 581.520691,956.492554  C580.878357,954.710510 580.499939,952.833374 579.999939,951.000000  "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M952.500000,1099.000000  C961.666687,1101.673340 970.879028,1100.112915 979.989014,1098.916504  C992.850220,1097.227417 1005.326172,1094.017700 1016.499451,1086.999146  C1023.096985,1082.854980 1029.635010,1078.542725 1033.460205,1071.478516  C1040.228638,1058.978638 1036.868896,1047.300781 1029.425781,1036.551392  C1019.256226,1021.864746 1004.159851,1016.029297 986.998535,1014.516418  C982.007935,1014.076477 977.000000,1013.833374 972.000000,1013.500061  "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M929.500000,1012.500000  C928.163025,1012.637390 926.743958,1012.118469 925.500000,1013.000000  "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 23,
    d: " M897.000000,1013.250000  C882.666687,1014.166687 868.290222,1014.662048 854.012451,1016.121826  C840.504272,1017.502869 826.969482,1018.642273 813.473511,1020.281982  C795.218811,1022.500000 777.059387,1025.158936 759.013550,1028.571655  C747.805603,1030.691162 736.659668,1032.991577 725.936340,1037.343018  C716.090881,1041.338135 708.143494,1050.797852 707.926392,1064.498779  C707.896667,1066.378174 709.503479,1069.198242 706.000000,1070.000000  "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M1448.000000,348.500000  C1447.955933,354.643921 1446.201172,360.152161 1443.092163,365.553070  C1435.172729,379.311401 1423.617432,389.661285 1411.988525,399.987061  C1404.215820,406.888672 1396.604004,414.010468 1388.446289,420.431885  C1368.538452,436.102875 1345.803345,445.710205 1320.996338,450.480927  C1306.794678,453.212067 1292.476318,454.750977 1278.018311,455.761597  C1267.525391,456.494995 1256.785400,455.902405 1246.500000,459.000000  "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14,
    d: " M1220.500000,497.000000  C1224.698242,507.545898 1223.553589,518.258728 1221.500000,529.000000  "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 21,
    d: " M586.000000,1170.500000  C589.986816,1162.889282 588.296936,1154.936035 587.530273,1146.997070  C586.498718,1136.314087 586.786865,1125.505859 584.027283,1114.992798  C580.619812,1102.011353 576.027893,1089.601074 567.489563,1079.008423  C560.913635,1070.850098 550.752502,1068.176147 541.012329,1073.024780  C526.065979,1080.464966 516.984863,1092.750977 514.710999,1109.029419  C512.661194,1123.703369 524.101990,1139.600952 540.511292,1142.434692  C546.923828,1143.542114 553.155334,1136.634399 554.641479,1129.027588  C556.328796,1120.390869 551.171936,1114.349609 547.951599,1107.522827  C547.016663,1105.540894 545.500000,1103.833374 544.250000,1102.000000  "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    d: " M1444.250000,413.500000  C1425.988647,435.256653 1407.025391,456.301270 1382.981445,471.971436  C1369.884521,480.507111 1355.075928,484.650635 1340.003174,488.014069  C1333.716919,489.416809 1327.736694,491.607941 1322.500000,495.500000  "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    d: " M1275.000000,508.500000  C1268.940308,509.966125 1263.795898,513.228821 1259.028931,517.036194  C1252.744507,522.055542 1247.073364,527.954773 1240.388428,532.329468  C1233.364990,536.925537 1230.106323,543.820557 1225.865845,550.413757  C1219.333740,560.570068 1212.922852,570.733215 1208.522217,582.008667  C1200.612671,602.274536 1196.956055,623.119202 1198.816772,645.015564  C1199.650391,654.825500 1200.512695,664.439148 1204.546875,673.479065  C1206.091919,676.941101 1207.788940,680.454590 1210.069824,683.446838  C1217.319092,692.957275 1232.825439,694.972290 1242.997192,687.995850  C1246.848022,685.354736 1250.666748,682.666687 1254.500000,680.000061  "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M1111.000000,755.500000  C1103.247070,746.330139 1092.592651,744.312622 1081.498657,744.058533  C1049.921875,743.335327 1022.976990,754.819946 999.457275,775.451294  C988.491150,785.070740 980.509521,796.637573 975.034363,810.014099  C972.296082,816.704224 971.029175,823.745605 971.521729,830.998535  C972.032410,838.519043 975.459351,844.405273 981.429749,849.089539  C983.695312,850.867004 985.059326,850.533386 987.020752,849.027039  C992.389221,844.903992 997.806213,840.862061 1003.057068,836.569824  C1017.109436,825.082825 1032.997803,816.734314 1050.004517,810.512390  C1075.455811,801.201111 1099.234497,789.127502 1118.500000,769.500000  "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 23,
    d: " M1046.000000,710.500000  C1047.097656,704.850586 1048.187622,699.182434 1049.255493,693.548462  C1052.145996,678.299316 1045.837524,667.378296 1034.981079,658.021912  C1032.105835,655.543823 1029.066284,653.241150 1025.982178,651.024902  C1022.638977,648.622498 1018.545349,649.728638 1014.999573,649.721619  C1004.499939,649.700745 994.225647,651.617981 984.485962,655.968506  C970.171814,662.362305 961.116882,673.342529 958.763062,688.540771  C957.007202,699.878540 961.717163,710.233337 968.467407,719.523682  C975.014648,728.534546 984.035339,730.920044 994.500671,730.008057  C1003.324158,729.239136 1011.419250,726.922363 1015.941895,718.468933  C1019.586975,711.655823 1018.500671,700.942993 1013.563171,695.443237  C1007.745911,688.963562 1002.533020,688.738159 997.024048,695.519531  C994.775757,698.286987 992.188232,699.983276 988.500000,699.500000  "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M885.000000,558.500000  C885.999023,549.476807 891.126404,541.768677 893.048401,533.010620  C896.098206,519.114014 895.176941,505.475067 890.970886,492.009094  C888.472717,484.011292 884.416687,476.798950 879.538391,469.972595  C871.932678,459.329834 850.590881,450.654663 835.500000,457.000000  "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 23,
    d: " M1353.000000,207.000000  C1361.037231,204.321671 1365.724854,198.030182 1370.597046,191.573181  C1379.781616,179.400955 1391.241455,169.235733 1401.496704,157.996994  C1404.678345,154.510101 1407.690430,150.857040 1411.500000,148.000000  "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 23,
    d: " M1433.500000,148.000000  C1435.921875,153.431656 1434.956909,159.042923 1433.928101,164.486404  C1431.667847,176.445282 1429.013916,188.339676 1425.463623,199.988922  C1420.240234,217.128128 1411.652710,232.388626 1400.651489,246.617142  C1389.596191,260.915466 1376.162354,272.508942 1362.500000,284.000000  "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: " M1134.500000,319.000000  C1137.166748,336.500000 1140.123169,353.961853 1142.432617,371.508881  C1145.970459,398.387970 1142.567017,424.440216 1132.041016,449.517212  C1130.413818,453.393890 1129.333374,457.500000 1128.000000,461.500000  "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    d: " M826.500000,662.500000  C825.834351,674.860352 828.444519,687.145630 827.470703,699.497681  C825.941223,718.894958 818.602539,735.575012 801.892151,746.332458  C788.455200,754.982544 773.223022,757.561890 757.519165,753.427246  C739.437744,748.666626 731.972046,734.477234 727.549805,717.986633  C726.860229,715.415466 726.854492,712.663818 726.490112,710.001343  C726.335815,708.873840 726.192810,707.640503 724.500000,708.000000  "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 18,
    d: " M768.000000,694.000000  C763.727295,698.868103 761.618591,704.567139 760.949341,710.994751  C760.153198,718.641235 766.832092,723.603760 774.012634,723.318970  C788.432678,722.747009 802.033813,705.750061 799.899170,690.514099  C798.873657,683.194153 795.162537,676.964172 787.974426,674.063354  C767.516846,665.807617 730.008240,672.578552 726.483765,706.498291  C726.447754,706.845215 726.166626,707.166626 725.999939,707.500000  "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: " M1019.250000,440.000000  C1025.341064,449.267883 1027.282471,459.991669 1029.380249,470.523865  C1031.702881,482.184814 1032.775879,494.155762 1031.862061,505.989349  C1029.663574,534.458191 1025.917725,562.694519 1007.916626,586.436768  C1001.578918,594.795776 995.227844,603.346191 986.008240,609.013367  C984.196960,610.126709 983.684692,612.068237 983.250000,614.000000  "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: " M1041.000000,28.500000  C1047.567505,31.316887 1054.518677,31.600342 1061.499756,31.486391  C1094.618408,30.945807 1123.288696,42.678413 1147.874023,64.144257  C1161.432495,75.982338 1168.447266,91.014076 1166.750977,110.022400  C1165.397461,125.191917 1158.769897,137.383392 1150.000000,149.000000  "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 18,
    d: " M877.250000,826.000000  C881.458557,832.195190 886.276855,837.913452 890.125305,844.425964  C897.216858,856.426514 900.558960,869.401978 902.595398,882.985718  C903.718567,890.477600 903.835205,898.015442 904.310669,905.512024  C904.708008,911.776733 903.281128,918.119873 903.444763,924.501404  C903.666748,933.162415 903.416382,941.834412 903.529236,950.499634  C903.604797,956.304260 904.842957,962.019287 906.609619,967.464417  C909.331238,975.852783 914.132996,978.500000 924.500000,978.500000  "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: " M552.250000,993.500000  C539.182373,966.908264 517.884277,952.020813 488.503235,948.473083  C477.059845,947.091370 465.683472,946.419250 454.503784,950.011780  C437.623352,955.436401 425.115234,966.431335 415.521301,981.014038  C412.293915,985.919617 408.061310,990.215576 406.250000,996.000000  "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25,
    d: " M874.750000,230.500000  C879.358582,237.760391 882.658630,245.903885 889.008423,251.991211  C903.394348,265.782440 920.606995,272.614929 940.493530,273.626648  C949.626282,274.091248 958.556091,273.509949 967.500000,272.000000  "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13,
    d: " M865.500000,1050.000000  C870.628113,1050.550049 875.803040,1051.118164 879.981506,1054.522705  C887.535461,1060.677368 889.250427,1069.044067 885.809082,1078.933594  C878.511292,1099.904907 865.464722,1116.969116 846.956848,1129.435913  C835.783386,1136.962402 823.729126,1142.876953 810.490906,1145.960938  C807.218628,1146.723145 803.846375,1147.279297 800.497009,1147.435303  C795.361877,1147.674316 791.783020,1144.941895 789.529724,1140.484985  C788.604431,1138.654541 787.722229,1137.427490 785.599670,1136.310547  C778.988220,1132.831299 776.148682,1124.271729 777.983398,1116.496094  C782.198975,1098.630127 791.232605,1083.470337 803.466614,1069.969727  C812.674683,1059.808350 823.194092,1051.608643 835.998230,1046.495605  C840.181458,1044.825195 844.619934,1044.191284 849.009338,1043.565552  C855.456543,1042.646240 860.858337,1044.900024 865.000000,1050.000000  "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25,
    d: " M836.000000,128.000000  C832.869202,132.138855 830.818237,137.349030 827.297668,140.793198  C819.479065,148.442123 815.726135,158.198471 811.028503,167.514359  C804.814575,179.837341 796.694885,191.136093 791.500000,204.000000  "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 19,
    d: " M670.000000,1049.500000  C668.432983,1052.322144 668.374573,1055.345825 668.455627,1058.501099  C668.830566,1073.095947 669.936279,1087.669922 672.631897,1101.975098  C677.159912,1126.004761 686.389099,1148.138306 700.903320,1168.070435  C708.287476,1178.210815 717.693604,1184.873169 729.500000,1188.500000  "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M984.000000,851.000000  C984.847473,858.488281 986.329041,865.731689 989.916626,872.543884  C993.013855,878.425110 998.024109,880.886658 1003.988281,882.542236  C1013.542603,885.194458 1022.735657,882.971802 1032.002686,881.012878  C1051.882690,876.810547 1070.198120,868.330444 1088.417236,859.822815  C1096.504028,856.046570 1104.561157,855.666321 1113.000000,856.000000  "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 21,
    d: " M643.000000,1045.500000  C636.562134,1059.055176 639.325134,1073.150879 641.124390,1086.983765  C644.011047,1109.177979 648.953857,1130.952637 660.588623,1150.447144  C667.763367,1162.468628 672.768066,1175.450684 678.750000,1188.000000  "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 23,
    d: " M417.000000,923.000000  C405.555664,927.285156 397.625549,935.440552 392.028137,946.014893  C387.390808,954.775513 382.977417,963.655396 378.535797,972.517944  C378.101776,973.383911 378.166656,974.500000 378.000000,975.500000  "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 19,
    d: " M1198.750000,121.500038  C1202.000000,116.666710 1205.529419,111.995171 1208.441772,106.966324  C1214.507568,96.492310 1213.676514,85.580055 1210.036499,74.488007  C1205.484497,60.616608 1196.309448,50.233894 1185.500000,41.000000  "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M851.500000,655.000000  C851.488831,653.104004 851.845886,651.332153 852.427856,649.477356  C855.594177,639.386597 856.417725,628.890320 855.347595,618.515747  C853.784851,603.365417 847.737244,589.797791 837.982361,578.014587  C833.626282,572.752808 828.990540,567.754883 822.500000,565.000000  "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: " M794.000000,561.500000  C785.944458,564.801575 778.572571,568.920898 772.405273,575.409973  C763.559204,584.717468 759.690308,595.343689 761.526306,607.996155  C762.467102,614.479553 763.776672,620.675964 767.317078,626.609131  C772.867310,635.910095 786.878113,639.138428 797.040955,627.535889  C804.195740,619.367554 804.738159,610.304260 801.750000,600.500000  "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M1062.000000,573.000000  C1053.620605,589.675293 1043.156860,605.179260 1034.826904,621.913879  C1030.386475,630.834595 1028.342163,640.463989 1024.500000,649.500000  "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M1377.500000,624.000000  C1382.892822,636.637939 1377.847168,647.725037 1371.359985,657.910828  C1360.030518,675.700012 1343.180664,686.628845 1323.504883,693.513916  C1315.994385,696.142090 1308.289551,698.068359 1300.484009,699.406738  C1294.630981,700.410461 1289.208374,702.291870 1284.000000,705.000000  "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 19,
    d: " M1456.500000,340.500000  C1455.440918,342.774261 1453.083740,343.754242 1451.509644,345.508606  C1449.513672,347.732971 1447.424805,348.405548 1444.473633,347.057678  C1438.626953,344.387329 1432.639038,344.914978 1426.484863,346.438660  C1407.659546,351.099426 1388.652832,354.974121 1369.486694,357.913116  C1359.729370,359.409302 1349.852783,360.376038 1339.994019,360.883636  C1331.772583,361.306946 1324.815674,357.073486 1318.012695,352.978912  C1316.592041,352.123840 1315.333374,350.999969 1314.000000,349.999969  "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15,
    d: " M1201.000000,10.250000  C1206.447754,13.817843 1212.719849,15.630893 1218.519165,18.460688  C1229.756470,23.943806 1240.434082,30.050678 1248.539673,39.967613  C1257.167603,50.523689 1261.712524,62.107807 1260.075562,76.008904  C1258.348511,90.676064 1253.755737,104.444557 1248.250000,118.000000  "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 23,
    d: " M1185.000000,221.500000  C1185.082153,226.119644 1183.009888,230.346207 1180.799194,233.874176  C1176.166992,241.266861 1176.280762,249.230530 1177.166260,256.981018  C1179.770386,279.773865 1183.735840,302.428284 1182.995728,325.499847  C1182.620850,337.184296 1181.058105,348.701660 1178.000000,360.000000  "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 18,
    d: " M847.500000,856.750000  C854.211426,861.303467 856.669861,868.657104 860.046387,875.477051  C865.614258,886.723511 866.313293,898.816956 867.050537,910.996948  C867.818054,923.677368 867.496094,936.337463 866.968323,948.998657  C866.546143,959.126099 867.954956,968.937256 871.250000,978.500000  "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 19,
    d: " M609.500000,1054.500000  C606.953796,1065.911011 606.982544,1077.448975 608.028381,1088.997437  C609.329590,1103.365479 610.632568,1117.750000 615.497864,1131.500732  C618.942139,1141.235474 622.765991,1150.802979 627.475037,1160.012695  C630.331543,1165.599365 634.916809,1169.079590 640.500000,1171.500000  "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    d: " M930.500000,462.000000  C930.247192,458.950317 931.170288,456.280579 932.413452,453.461823  C937.943665,440.922638 941.393127,427.842896 940.449219,414.003479  C939.649353,402.274750 936.196899,391.659729 925.485229,385.023834  C913.694458,377.719452 890.687256,383.318115 887.425781,399.485046  C884.803650,412.482880 897.248718,426.263947 910.501831,424.514069  C911.320923,424.405945 912.166687,424.500000 913.000000,424.500000  "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    d: " M991.500000,922.500000  C1010.156677,923.439941 1028.030396,919.682617 1045.500000,913.500000  "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M1067.500000,916.500000  C1070.678345,921.179443 1070.339355,926.872620 1071.935547,932.019958  C1078.713867,953.879150 1091.137817,970.832703 1112.476074,980.552673  C1120.966553,984.420349 1130.005371,984.993530 1139.004272,985.960266  C1144.147339,986.512695 1149.333374,986.666687 1154.500000,987.000000  "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 19,
    d: " M1372.000000,616.000000  C1363.585327,618.967834 1356.299438,624.319214 1347.990479,627.474854  C1324.228516,636.499084 1301.038818,647.048462 1276.519531,654.068298  C1270.554932,655.776001 1264.833374,658.333435 1259.000000,660.500061  "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M1277.500000,773.000000  C1278.587036,767.272400 1273.697510,765.030945 1270.392700,763.192993  C1254.005737,754.079590 1236.491089,748.061218 1217.500122,748.089417  C1204.534302,748.108704 1192.013794,751.168884 1180.033936,756.082825  C1176.839966,757.392944 1173.228149,757.853271 1170.500000,760.250000  "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 18,
    d: " M1292.500000,508.000000  C1292.371704,514.816528 1291.177856,521.205811 1288.156860,527.574402  C1282.100220,540.342468 1278.496094,553.966553 1276.474121,567.996277  C1274.765991,579.847656 1272.833374,591.666687 1271.000000,603.500000  "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M1263.000000,689.000000  C1268.443481,694.622375 1275.611328,697.956604 1281.540527,702.951843  C1283.438477,704.550781 1284.563721,705.880676 1283.545776,708.517639  C1281.736938,713.203308 1284.464600,716.206543 1288.022095,718.465210  C1296.425171,723.800415 1305.446655,728.209717 1312.550293,735.450745  C1313.485229,736.403748 1315.131104,736.234802 1316.500000,735.750000  "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 19,
    d: " M451.500000,616.500000  C449.792389,607.745239 450.298401,598.823364 449.503815,589.999634  C449.474030,589.669006 449.577759,589.310669 449.488403,589.003357  C448.082550,584.169067 447.546814,578.128235 441.470856,577.188354  C435.027252,576.191650 428.566406,576.922180 423.959320,582.968994  C416.634857,592.582458 415.568878,605.915466 421.464203,616.519897  C422.872162,619.052429 423.833344,621.833313 425.000000,624.500000  "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M705.500000,725.000000  C687.476074,724.975159 669.730896,726.583984 652.469727,732.410278  C641.879456,735.984863 632.809204,741.797180 624.538452,749.043884  C622.048584,751.225342 619.720276,753.553467 617.060364,755.579224  C614.407288,757.599609 611.683716,758.357971 608.500000,758.000000  "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14,
    d: " M865.000000,1050.500000  C860.666626,1057.166626 856.387939,1063.869751 851.984558,1070.489746  C847.619080,1077.052979 842.450745,1082.649658 835.032043,1086.069458  C825.096985,1090.649414 817.758362,1098.268921 813.086670,1108.041382  C807.357117,1120.026978 798.815918,1129.451660 788.500000,1137.500000  "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M976.500000,956.500000  C979.424744,956.134277 981.857544,957.773376 984.488281,958.540222  C993.535645,961.177429 1002.205078,958.343628 1011.004272,957.028564  C1019.677246,955.732361 1028.054077,952.790527 1037.001221,952.871582  C1040.518555,952.903503 1042.549927,953.989380 1044.020508,956.989929  C1047.792603,964.686646 1051.942261,972.211304 1055.407593,980.040894  C1057.910156,985.695374 1061.560791,990.500366 1065.000000,995.500000  "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25,
    d: " M730.750000,155.000000  C727.166687,161.500000 723.443848,167.927643 720.026428,174.513718  C710.155396,193.537430 697.780701,211.153900 688.544861,230.521378  C685.696533,236.494385 681.559814,242.007675 681.250000,249.000000  "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: " M830.500000,892.500000  C832.408264,895.564575 833.085083,898.865234 833.048279,902.500488  C832.898010,917.339355 832.894470,932.168884 832.108398,947.005737  C831.484436,958.783203 833.528748,970.359314 837.612305,981.458679  C838.122314,982.844788 838.434998,984.099609 838.500000,985.500000  "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 21,
    d: " M1320.000000,501.500000  C1328.041382,508.355865 1329.724976,517.748047 1329.945068,527.501221  C1330.342041,545.084290 1330.230103,562.654785 1324.000000,579.500000  "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M636.500000,345.500000  C642.616089,354.253601 644.073853,363.982971 643.640808,374.505798  C643.161560,386.150909 642.475525,397.619904 639.682068,409.044525  C637.630737,417.433990 633.464783,424.205963 628.000000,430.500000  "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    d: " M1268.500000,7.500000  C1271.109619,11.144222 1272.497681,15.339387 1274.019165,19.492966  C1277.755737,29.692793 1284.562378,37.984177 1290.997314,46.502018  C1298.179077,56.008053 1301.161499,66.659393 1299.472778,78.496109  C1298.901855,82.497078 1296.849854,85.990158 1294.951782,89.473747  C1294.151489,90.942764 1292.408203,90.465912 1291.000000,90.500000  "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    d: " M1437.000000,459.000000  C1428.442017,473.754059 1418.368652,487.283813 1404.466553,497.454224  C1393.502930,505.474792 1381.373169,511.145416 1368.012451,514.057190  C1366.339478,514.421814 1364.886963,515.734436 1363.000000,515.500000  "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14,
    d: " M516.500000,676.750000  C503.758789,678.651001 493.797546,686.512329 483.034058,692.560608  C469.079346,700.402039 453.838135,704.286133 438.497986,707.991638  C434.744293,708.898315 430.919189,709.555603 427.500000,711.500000  "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M1233.500000,196.500000  C1228.643921,195.580841 1226.855957,198.260391 1225.389771,202.461548  C1222.807739,209.860931 1223.674438,217.490829 1223.061890,225.005051  C1221.923096,238.975250 1223.116211,253.071381 1220.982422,266.997314  C1220.519775,270.015808 1219.833374,273.000000 1219.250000,276.000000  "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 23,
    d: " M791.750000,921.500000  C797.795349,934.873596 798.269836,949.215088 798.968750,963.501526  C799.172058,967.658264 799.240234,971.850220 798.948792,975.996399  C798.387207,983.984802 800.190552,991.319885 804.585938,997.942932  C805.274963,998.981079 805.282532,1000.021179 805.750000,1001.000000  "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 21,
    d: " M900.500000,736.500000  C902.691772,748.929993 901.858887,761.645203 905.280151,774.060608  C909.152466,788.112732 915.781860,799.796875 927.501526,808.497925  C928.804565,809.465332 930.070801,810.458069 930.750000,812.000000  "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M1222.500000,788.500000  C1211.736328,783.430664 1201.705078,786.952637 1192.041626,791.586914  C1183.193359,795.830322 1174.866577,801.196472 1167.111084,807.144836  C1160.109375,812.515137 1152.538696,815.026245 1144.000000,815.500000  "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M1360.500000,130.500000  C1349.496094,148.640259 1345.342407,168.505280 1345.457031,189.500229  C1345.487793,195.138657 1346.948120,200.227921 1350.581909,204.429199  C1352.301758,206.417725 1352.416748,208.077835 1352.085693,210.511658  C1350.570801,221.646408 1345.322998,231.097519 1338.950928,239.964737  C1330.924072,251.134659 1325.205933,263.784210 1316.539551,274.531891  C1316.066772,275.118408 1316.154175,276.164398 1316.001953,277.000336  C1314.398804,285.800507 1310.237183,293.354248 1305.107422,300.576324  C1303.328857,303.080444 1301.247803,303.562317 1299.026123,302.910919  C1292.625854,301.034485 1285.987671,301.080109 1279.500000,300.000000  "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14,
    d: " M718.500000,869.750000  C712.259583,874.339722 707.320251,880.056213 702.929993,886.451965  C694.828186,898.254761 684.249329,907.339172 670.983032,912.959961  C662.649658,916.490784 655.079224,921.184082 648.000000,926.750000  "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25,
    d: " M783.000000,255.500000  C782.298645,249.347778 782.163452,243.217896 782.359924,236.995575  C782.715881,225.721771 775.429688,217.156647 761.590027,223.690735  C754.093750,227.229935 746.638123,230.188782 738.500000,231.500000  "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M1314.250000,154.500000  C1308.435913,164.793427 1308.178345,176.245789 1308.141113,187.500473  C1308.091675,202.459793 1304.672607,216.583511 1299.750000,230.500000  "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 23,
    d: " M1270.000000,171.500000  C1268.556030,174.330383 1267.791504,177.217987 1267.345703,180.478912  C1264.848267,198.748108 1264.392090,217.138489 1263.625244,235.505234  C1263.497803,238.556931 1261.218262,239.775803 1260.250000,242.000000  "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 18,
    d: " M1103.500000,406.500000  C1107.196167,425.286407 1101.331299,442.148254 1092.966675,458.482910  C1092.217896,459.944916 1091.000000,461.166656 1090.000000,462.500000  "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 23,
    d: " M931.500000,695.000000  C931.180725,706.007385 929.915222,717.009888 931.972168,728.005188  C934.614197,742.127869 941.476685,753.468140 953.517761,761.473328  C955.881348,763.044617 958.574280,763.869507 961.500000,763.500000  "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25,
    d: " M526.750000,359.000000  C522.692810,366.863281 522.142090,375.528015 522.155640,383.999756  C522.179504,398.890045 520.003418,413.636871 520.000000,428.500000  "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 18,
    d: " M926.000000,326.500000  C930.099121,332.817719 936.433167,336.520294 942.511169,340.482819  C954.650696,348.396973 962.571777,359.269287 965.389954,373.521759  C966.025085,376.734192 967.742065,379.204254 969.000000,382.000000  "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 21,
    d: " M727.500000,590.500000  C727.405640,603.356506 727.526672,616.206909 729.013306,628.998474  C729.713867,635.026489 731.137878,640.920288 733.551636,646.477600  C735.873596,651.823364 736.941711,657.518555 738.750000,663.000000  "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: " M510.500000,994.000000  C508.055145,994.512024 506.437439,992.522095 505.101746,991.380920  C490.591919,978.984192 475.438629,981.054749 460.040710,989.078125  C457.254944,990.529663 454.667542,992.715393 452.622284,995.104675  C451.356750,996.583130 450.076843,996.932922 448.500000,997.250000  "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M764.500000,947.500000  C769.847839,958.672852 767.508423,970.451111 766.861877,981.992249  C766.460510,989.156067 766.838501,996.422119 765.085205,1003.521057  C764.598999,1005.489685 767.190613,1007.202332 766.500000,1009.500000  "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 21,
    d: " M995.750000,503.500000  C998.211914,510.288452 999.718689,517.288513 999.976074,524.500854  C1000.436340,537.400574 995.908386,548.725159 988.421814,558.942688  C987.095886,560.752319 985.767334,562.508057 984.750000,564.500000  "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13,
    d: " M1272.000000,285.500000  C1266.313354,284.986328 1260.622070,284.439453 1255.000977,286.003510  C1247.423096,288.112030 1242.022583,293.811951 1241.916382,302.498962  C1241.826416,309.852386 1242.573975,316.898621 1246.000000,323.500000  "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17,
    d: " M1123.000000,499.500000  C1129.181641,509.527832 1131.215820,521.085876 1135.023926,531.991638  C1136.852539,537.228577 1137.440674,543.336304 1143.995850,545.512329  C1151.555664,548.021912 1158.898193,547.825134 1165.998535,543.997253  C1173.862671,539.757507 1178.015625,531.975098 1183.400879,525.418579  C1185.166504,523.269104 1183.311646,520.170776 1183.333984,517.498596  C1183.349976,515.589966 1182.415161,513.569702 1182.500000,511.500000  "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 18,
    d: " M413.500000,884.000000  C408.599579,889.085510 402.424469,892.356812 396.509247,896.014954  C386.231384,902.371155 379.244446,911.272888 375.997681,922.999329  C374.730438,927.576172 373.555328,932.185120 371.500000,936.500000  "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14,
    d: " M1283.500000,360.500000  C1277.908813,352.462250 1275.130005,343.018402 1270.501343,334.499268  C1270.323608,334.171967 1270.126953,333.847107 1270.005737,333.497986  C1267.521606,326.349335 1262.333374,324.479004 1255.034912,323.680725  C1246.785400,322.778442 1242.105713,326.515961 1237.475830,331.979553  C1231.237427,339.341492 1229.019775,348.523529 1235.939087,358.542053  C1238.389526,362.089935 1240.779907,365.609406 1244.000000,368.500000  "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 11,
    d: " M1315.500000,275.000000  C1313.000000,273.500000 1310.439331,272.091644 1308.010010,270.484863  C1294.405151,261.486359 1285.422363,265.258148 1277.034424,276.026794  C1275.624268,277.837128 1274.484619,279.919006 1273.548828,282.021759  C1272.521851,284.329468 1272.077637,286.534088 1273.924805,289.055084  C1278.901611,295.847260 1279.556030,302.466583 1273.657471,309.629639  C1269.977173,314.098907 1267.833252,319.833313 1265.000000,324.999969  "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25,
    d: " M953.000000,315.250000  C943.011719,316.063446 933.179749,317.357086 926.065002,325.556396  C925.412903,326.307861 924.914978,325.986267 924.504028,325.951813  C916.586853,325.288177 908.895569,327.974579 901.000000,327.500000  "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M1328.750000,45.500000  C1332.669312,56.391533 1333.223755,67.631638 1331.949219,78.994308  C1331.421997,83.695305 1330.333252,88.333328 1329.500000,92.999992  "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    d: " M495.500000,1053.500000  C494.872589,1059.247925 492.632721,1064.485596 489.950195,1069.473267  C485.140228,1078.416504 482.792023,1087.865112 482.982269,1098.000366  C483.073364,1102.853882 483.191895,1107.725830 482.000000,1112.500000  "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14,
    d: " M1283.000000,714.000000  C1269.183838,719.706604 1254.603516,719.936157 1240.000000,720.000000  "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 21,
    d: " M435.000000,791.500000  C435.166687,792.666687 434.901276,794.250122 435.564575,794.937683  C446.070251,805.828430 452.316803,819.377136 459.250000,832.500000  "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M859.500000,1095.500000  C856.839172,1096.839111 855.029968,1099.291870 853.620667,1101.574463  C848.101562,1110.513794 840.366333,1116.273438 830.523254,1119.569458  C829.023254,1120.071655 827.835205,1121.502563 826.497437,1122.496582  C826.350220,1122.605957 826.166687,1122.666748 826.000000,1122.750000  C826.083313,1122.833374 826.166687,1122.916626 826.250000,1123.000000  "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: " M1230.500000,538.000000  C1228.333374,535.833313 1226.001099,533.805054 1224.044189,531.463013  C1221.865723,528.855774 1219.643921,529.199951 1216.989380,530.477966  C1206.905151,535.332947 1197.330688,534.998047 1188.480225,527.523438  C1187.291138,526.519287 1185.833374,525.833374 1184.500000,525.000000  "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: " M698.500000,628.000000  C701.874207,640.982178 701.889709,654.541260 705.362061,667.536865  C706.276489,670.959229 705.500000,674.833313 705.500000,678.500000  "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M1150.000000,490.000000  C1159.146240,498.628448 1171.203735,502.856018 1180.991089,510.511444  C1182.057373,511.345459 1183.095215,511.065552 1183.984985,510.477356  C1191.554932,505.472809 1199.820435,501.419800 1206.000000,494.500000  "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1428.000000,112.500000  C1428.036743,121.031570 1427.856934,129.550400 1426.500000,138.000000  "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M395.500000,723.500000  C393.833344,723.666626 391.910583,723.353821 390.544525,724.083374  C384.774323,727.164917 378.896271,725.768005 373.000000,725.000000  "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M748.000000,348.500000  C750.004211,350.221527 748.588623,352.513000 749.000000,354.500000  "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 21,
    d: " M843.500000,309.500000  C823.440918,311.261963 809.587036,323.463684 797.043762,337.539001  C780.994324,355.548645 770.108704,376.581757 761.371460,398.949799  C757.000305,410.140411 751.720520,421.048431 744.000000,430.500000  "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M708.000000,469.500000  C688.831543,489.286041 670.992371,510.229553 653.424561,531.437500  C641.351624,546.012024 628.524841,559.969421 617.028870,575.022034  C604.888428,590.918518 594.523132,607.914795 587.060364,626.524231  C583.679199,634.955750 581.696533,643.783142 582.507751,652.999329  C583.460632,663.825684 590.587158,671.089844 603.524780,668.630249  C620.318420,665.437683 633.221497,655.857422 645.479004,644.976318  C659.453613,632.570923 669.848816,617.010742 681.929871,602.939758  C694.577087,588.209290 706.737061,573.057190 718.984009,557.987000  C738.635498,533.804993 754.311890,507.186554 767.568481,479.032227  C774.800659,463.672516 781.425171,447.931366 792.948120,434.953918  C801.006042,425.878845 810.846375,419.084412 820.500000,412.000000  "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22,
    d: " M855.000000,379.000000  C862.051270,370.098450 868.496765,360.883514 871.011475,349.502533  C874.520203,333.623352 869.203003,319.437592 858.025940,312.458466  C853.629211,309.713104 848.901855,309.402405 844.000000,309.500000  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f4a3f25e427bb98f9be60fee33aecf00.svg";
export { ForwardRef as ReactComponent };